/* 1.引入文件 */
import axios from "axios"; //引入 axios库
import qs from "qs"; //引入 node中自带的qs模块（数据格式转换）
import router from '../router'
import Vue from 'vue'
import store from '../store'
import { Message } from 'element-ui'
// Vue.use(Message)

/*你也可以创建一个实例，然后在实例中配置相关属性，此方法和上面的方法一样，写法不同，怎么用随个人
 *喜好，我比较喜欢用这种方法，如下：
 */
let baseURL = ''
if (process.env.VUE_APP_ENV === "development") {
	console.log('process.env.NODE_ENV' + process.env.NODE_ENV)
	baseURL = ""
} else {
	console.log('process.env.NODE_ENV' + process.env.NODE_ENV)
	baseURL ="http://112.126.65.249:9000"
}
const http = axios.create({
	baseURL: baseURL, // 后台服务地址
	timeout: 30000, // 请求超时时间30秒
	responseType: "json",
	withCredentials: false // 是否允许带cookie这些
});
/* 3.设置拦截器 */

/*如果不是用创建实例的方式配置，那么下面的Axios都要换成axios,也就是文件开头你用import引入axios
时定义的变量*/
http.interceptors.request.use(
	config => {
		if (config.method == "post") {
			if (config.headers["Content-Type"] == "application/x-www-form-urlencoded") {
				config.data = qs.stringify(config.data, {
					arrayFormat: "repeat"
				});
			}
		}
		return config;
	},
	error => {
		console.log("错误的传参", "fail");
		return Promise.reject(error);
	}
);
http.interceptors.response.use(
	res => {
		console.log("[http.js] response:", res.config.url + " ：", res);
		// if (res.data.code == 200 || res.data.code == 999 || res.data.code == 99) { //测试环境总报999和99
		// 	store.commit('changeIsTimeOut', false)
		// } else if (res.data.code == 401 || res.data.code == 403) {
		// 	store.commit('changeIsTimeOut', false)
  //     Message({ message: res.data.msg });

		// } else if (res.data.code == 301 || res.data.code == 302 || res.data.code == 304) {
		// 	store.commit('changeIsTimeOut', false)
		// } else {
		// 	store.commit('changeIsTimeOut', true)
		// }
		// let token = null;
		// if (res.data.token) {
		//     token = res.data.token;
		//     if (token != localStorage.token) {
		//       console.log("token更新");
		//       // 更新储存 token
		//       localStorage.token = token
		//     }
		// }

		return res.data;
	},
	error => {
		//alert("网络异常!") 404,500等问题可以在这里处理
		store.commit('changeIsTimeOut', true)
		return Promise.reject("http.js error=" + error);
	}
);

export default http;



// WEBPACK FOOTER //
// ./src/config/http.js